import {observer} from "mobx-react";
import React, {useEffect} from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import LoadingInfinityScroll from "@dropDesk/presentation/components/loadings/loading_infinity_scroll";
import InputSearchGeneric from "@dropDesk/presentation/components/inputs/input_search";
import {SpinLoading} from "@dropDesk/presentation/components/loadings/spin";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ConstantsKeys} from "@dropDesk/domain/entities/constants/constants_keys";
import {InternalChatUserEntity} from "@dropDesk/domain/entities/internal_chat/users/internal_chat_user_entity";
import {
    Container, ContainerButtonEdit, ContainerHeader,
    ContainerInputSearch, ContainerUsers,
    Content,
    ContentLoading, ContentTextNoResults,
    Text, TextHeader
} from "@dropDesk/presentation/pages/chat/ui/internal_chat/list_users/styled";
import InternalChatUserList from "@dropDesk/presentation/components/internal_chat_users_list";
import ButtonNew from "@dropDesk/presentation/components/buttons/button_new";
import {CancelTokenManager} from "@dropDesk/data/clients/http.client";

export const InternalChatUsersLists = (observer((
    {
        loading,
        internalChatUsers,
        hasMore,
        loadMore,
        onSearch,
        maxWidthContainer,
        searchParam,
        onClickEditUsers,
        disposeListUsers
    }: {
        loading: boolean
        internalChatUsers: InternalChatUserEntity[]
        hasMore?: boolean
        loadMore: () => void
        onSearch: (value: string) => Promise<void>
        onClickEditUsers: () => void
        disposeListUsers: () => void
        searchParam: string
        maxWidthContainer: number
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    useEffect(() => {
        onSearch('');
        return () => {
            disposeListUsers();
        }
    }, []);

    return (
        <Container>
            <ContainerHeader>
                <TextHeader color={colors.text}>Participantes</TextHeader>
            </ContainerHeader>
            <ContainerButtonEdit>
                <ButtonNew
                    marginLeft={0}
                    label={'Editar participantes'}
                    onClick={onClickEditUsers}
                    nameLeftIcon={ICONS_DROPDESK.edit}
                    sizeLeftIcon={16}
                    disabled={false}
                    widthButton={568}
                    isButtonMain={true}
                />
            </ContainerButtonEdit>
            <ContainerUsers>
                <ContainerInputSearch>
                    <InputSearchGeneric
                        inputSearchPlaceholder="Pesquisar por participantes"
                        loading={loading}
                        onSearch={(value) => onSearch(value)}
                        size={'large'}
                        defaultLimitInputSearch={ConstantsKeys.defaultNewLimitInputSearch}
                    />
                </ContainerInputSearch>
                <Content>
                    {loading && internalChatUsers.length === 0 &&
                        <ContentLoading>
                            <SpinLoading
                                size={"large"}
                                color={colors.text}
                                tip={"Carregando ..."}
                            />
                        </ContentLoading>
                    }
                    {!loading && internalChatUsers.length === 0 &&
                        <ContentTextNoResults>
                            <DropDeskIcon icon={ICONS_DROPDESK.emptyFolder} size={55} color={colors.hintInverse}/>
                            <Text color={colors.text}>Nenhuma participante encontrado.</Text>
                        </ContentTextNoResults>
                    }

                    {internalChatUsers.map((_internalChatUser) => {
                        return (
                            <div key={_internalChatUser.idUser}>
                                <InternalChatUserList
                                    internalChatUser={_internalChatUser}
                                    searchParam={searchParam}
                                    maxWidthContainer={maxWidthContainer}
                                />
                            </div>
                        )
                    })}
                    {hasMore &&
                        <LoadingInfinityScroll
                            loading={loading && internalChatUsers.length > 0}
                            loadMore={() => loadMore()}
                            label={'Carregar mais participantes'}
                            labelLoading={'Carregando mais participantes...'}
                        />}

                </Content>
            </ContainerUsers>
        </Container>
    )
}));
